import Kordion from './core/core.mjs';

export default Kordion;
